export const appStrings: Record<string, string> = {
  'all-rights-reserved': 'All rights reserved',
  'back-to-login-label': 'Back to Login',
  'create-account-label': 'Create Account',
  'cookies-banner-message': 'This site uses cookies to offer you a better browsing experience. &lt;a href="https://trust.careevolution.com/mydatahelps/privacy.html" target="_blank"&gt;Learn more&lt;/a&gt;',
  'email-label': 'Email',
  'email-placeholder': '',
  'enable-mfa-info': 'Multi-factor authentication adds a layer of security to the login process by requiring you to supply additional identity verification.',
  'enable-mfa-snooze-label': 'Snooze Multi-Factor Authentication Setup',
  'enable-mfa-title': 'Set up Multi-Factor Authentication',
  'enable-mfa-use-passkey-label': 'Use Passkey',
  'enable-mfa-use-topt-label': 'Use Authenticator App',
  'error-account-locked-out-no-reset': 'Your account has been temporarily locked due to repeated failed login attempts.',
  'error-account-locked-out': 'Your account has been temporarily locked due to repeated failed login attempts. If we have an email address for you, an email has been sent to you with instructions on how to unlock your account.',
  'error-add-passkey-failed': 'Unable to add passkey.',
  'error-delete-passkey-failed': 'Unable to delete passkey.',
  'error-enable-totp-2fa-failed': 'Verification failed. Please try again.',
  'error-get-passkeys-failed': 'Unable to retrieve passkeys.',
  'error-get-passkey-authentication-options-failed': 'Unable to use passkeys.',
  'error-invalid-password-reset-nonce': 'Invalid verification code. Please select "Forgot Password" to try again.',
  'error-invalid-password': 'Invalid password. Please try again or select "Forgot password".',
  'error-save-passkey-failed': 'Unable to save passkey.',
  'error-verify-passkey-failed': 'Passkey verification was unsuccessful.',
  'first-name-label': 'First Name',
  'first-name-placeholder': '',
  'footer-product-link': 'https://careevolution.com',
  'footer-product-logo': 'https://rkstudio-customer-assets.s3.amazonaws.com/CareEvolution/ce-white.png',
  'footer-product-name': 'CareEvolution',
  'footer-contact-us-label': 'Contact Us',
  'footer-privacy-policy-label': 'Privacy and Use Policy',
  'footer-copyright-text': 'Copyright 2004-{{year}} CareEvolution, Inc. All rights reserved.',
  'forgot-password-title': 'Forgot Password',
  'forgot-password-text': 'Enter your email or username so a password reset email can be sent to you.',
  'forgot-password-label': 'Forgot Password',
  'initialize-password-title': 'Initialize Password',
  'join-title': 'Create an Account',
  'join-text': 'By registering, you agree to the',
  'join-privacy-link-label': 'MyDataHelps Designer Privacy and Use Policy',
  'join-email-disclaimer-text': 'We don’t sell or rent your email address.',
  'join-click-here-to-sign-in': 'click here to sign in',
  'join-existing-account': 'Already have an account?',
  'join-success-title': 'Thank you for registering',
  'join-success-info': 'You should receive an email shortly with instructions for activating your account.',
  'last-name-label': 'Last Name',
  'last-name-placeholder': '',
  'links-back': 'Back',
  'links-logout': 'Logout',
  'links-return-to-login': 'Return to Login',
  'login-click-here-to-join': 'Click here to join',
  'login-title': 'Welcome back!',
  'mdh-url': 'https://mydatahelps.org',
  'mfa-info': 'Multi-factor authentication adds a layer of security to the login process by requiring you to supply additional identity verification. Be sure you have at least two items configured below so that you can still access your account even while getting a new phone or laptop.',
  'mfa-passkey-cancel-label': 'Cancel',
  'mfa-passkey-date-created': 'Added ',
  'mfa-passkey-default-description': '',
  'mfa-passkey-remove-confirm': 'Are you sure you want to remove this passkey?',
  'mfa-passkey-remove-label': 'Remove',
  'mfa-passkey-rename-label': 'Rename',
  'mfa-passkey-save-label': 'Save',
  'mfa-passkeys-header': 'Passkeys',
  'mfa-recovery-codes-generate-label': 'Generate Recovery Codes',
  'mfa-recovery-codes-header': 'Recovery Codes',
  'mfa-recovery-codes-info': 'Recovery codes can be used in the event that access to the authenticator app is lost.',
  'mfa-title': 'Multi-Factor Authentication',
  'mfa-totp-add-label': 'Add Authenticator App',
  'mfa-totp-enabled-text': 'Authenticator app is enabled',
  'mfa-totp-header': 'Authenticator App',
  'mfa-totp-not-enabled-text': 'There is no authenticator app configured.',
  'mfa-totp-remove-confirm': 'Are you sure you want to remove the authenticator app?',
  'mfa-totp-remove-label': 'Remove Authenticator App',
  'next-label': 'Next',
  'passkey-add-label': 'Add Passkey',
  'passkey-info': 'Passkey verification uses cryptographic keys via your device\'s biometric capabilities (like fingerprint or face ID) or a PIN to securely provide identity verification.',
  'passkey-title': 'Passkey Verification',
  'password-label': 'Password',
  'password-placeholder': '',
  'password-requirement-classes': 'At least 3 of the following: <ul><li>upper case letters</li><li>lower case letters</li><li>digits</li><li>special characters</li></ul>',
  'password-requirement-common-words': 'No words or patterns commonly used by attackers',
  'password-requirement-length': 'At least 8 characters',
  'password-requirement-related-words': 'No user information or words related to MyDataHelps',
  'password-requirements-title': '',
  'privacy-policy-link': 'https://trust.careevolution.com/mydatahelps/privacy.html',
  'recovery-codes-info': 'Multi-factor authentication is now enabled. These recovery codes can be used to login in the event that you lose access to your passkey or authenticator app. Please make a copy and store them in a safe place.',
  'recovery-codes-submit-label': 'Continue',
  'recovery-codes-title': 'Recovery Codes',
  'remember-me': 'Remember Me',
  'reset-password-title': 'Reset Password',
  'reset-password-info': 'Please set a new password for account {{email}}.',
  'sign-in-label': 'Sign in',
  'totp-cancel-label': 'Cancel',
  'totp-code-label': '6-digit Code',
  'totp-enable-label': 'Enable Authenticator App',
  'totp-info': 'While logging in with app-based verification, you will be prompted for a 6-digit code generated by a mobile app. Follow the steps below to install and configure the mobile app.',
  'totp-instructions-1': '1. Install a free Authenticator mobile app, such as Google Authenticator.',
  'totp-instructions-2': '2. In the mobile app, configure a new account by scanning this QR code.',
  'totp-instructions-3': '3. Enter the 6-digit code displayed in the mobile app',
  'totp-instructions-code': 'If you are not able to scan the QR code, enter this key in the mobile app:',
  'totp-title': 'Authenticator App Verification',
  'totp-enable-failed': 'Confirmation code is incorrect',
  'try-mdh-message': 'Are you a study participant?',
  'try-mdh-sign-in-text': 'Sign into your MyDataHelps account',
  'username-label': 'Email or Username',
  'username-placeholder': '',
  'verification-code-label': 'Verification Code',
  'verify-mfa-info': '',
  'verify-mfa-passkey-info': 'You have a passkey saved for this site.',
  'verify-mfa-passkey-instructions-header': 'Passkey Verification',
  'verify-mfa-passkey-use-label': 'Use Passkey',
  'verify-mfa-recovery-code-label': 'Recovery Code',
  'verify-mfa-recovery-info': 'Enter a recovery code. Each recovery code can only be used once.',
  'verify-mfa-recovery-instructions-header': 'Recovery Code Verification',
  'verify-mfa-remember-me-in-days-label': 'Remember me for {{days}} days',
  'verify-mfa-remember-me-label': 'Remember me',
  'verify-mfa-submit-label': 'Submit',
  'verify-mfa-title': 'Multi-Factor Authentication',
  'verify-mfa-totp-info': 'Enter the 6-digit code generated by your authenticator mobile app for this site.',
  'verify-mfa-totp-instructions-header': 'App-based Verification',
  'verify-mfa-use-recovery-code-label': 'Use a recovery code',
  'verify-mfa-use-totp-code-label': 'Use your Authenticator App',
  'verify-nonce-info': 'A forgot password email has been sent to you at {{email}}. Follow the instructions in that email to reset your password. You can also manually enter the 10 digit verification code from the email to continue.',
  'verify-nonce-title': 'Forgot Password Verification',
}